import React, {useState, Fragment} from 'react';
import Swal from 'sweetalert2';


function Formulario(props) {

    const[datosCriterio, guardarCriterio] = useState({
        RUC : '',
        Folio  : '',
        Nombre_Sociedad  : ''
    });

    // leer los datos del formulario
    const actualizarState = e => {
        // Almacenar lo que el usuario escribe en el state
        guardarCriterio({
            // obtener una copia del state actual
            ...datosCriterio, 
            [e.target.name] : e.target.value
        })
        //console.log(datosCriterio)

    }

    // Validar el formulario
    const validarCriterio = e => {
        e.preventDefault();
        // Destructuring
        const { RUC,Folio,Nombre_Sociedad } = datosCriterio;

        // revisar que las propiedades del state tengan contenido
        let valido = !RUC.length  && !Folio.length && !Nombre_Sociedad.length;
        if (valido) {
            Swal.fire({
                icon: 'warning',
                title: 'No hay resultados',
                text: 'Especifica al menos un dato en la busqueda'
            })
        }else{
            props.obtenerFincas(datosCriterio)  
               
        }
    }

    

    return (
        <Fragment>
        <form 
            onSubmit={validarCriterio}
        >
            <br/>
            <div className="row">
                <h5 className="text-center col-md-12">Escribe el Ruc, Folio o Nombre de la sociedad y presiona clic en Buscar</h5>
            </div>
            <br/>
            <div className="row">
                
                <div className="form-group col-md-3">
                     <input 
                        name="RUC"
                        className="form-control form-control-lg" 
                        type="text" 
                        placeholder="Ruc"
                        onChange={actualizarState} 
                    />
                </div>
                <div className="form-group col-md-2">
                    <input 
                        name="Folio"
                        className="form-control form-control-lg" 
                        type="text" 
                        placeholder="Folio"
                        onChange={actualizarState} 
                    />
                </div>
                <div className="form-group col-md-4">
                    <input 
                        name="Nombre_Sociedad"
                        className="form-control form-control-lg" 
                        type="text" 
                        placeholder="Nombre de la Sociedad"
                        onChange={actualizarState} 
                    />
                </div>
                <div className="form-group col-md-3">
                    <input  type="submit" className="bnt btn-lg btn-primary btn-block"  value="Buscar"></input>
                </div>

                
            </div>
        </form>
        </Fragment> 
);

}


export default Formulario;